import React from 'react'

const ConectUs = () => {
    return (
        <div>
            
        </div>
    )
}

export default ConectUs
